import { getPlatformBaseUrl } from './platformBaseUrl';

export const cameraSlashImg = getPlatformBaseUrl(
  '/img/camera-slash-regular.svg'
);
